import { TakeawayServices } from './../../../takeaway/services';
import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { OrdersServices } from '../../../kitchen/services';
import { OrdersCoServices } from '../../../orders/services';
import { TranslateService } from '@ngx-translate/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { HttpClient } from '@angular/common/http';
import * as firebase from 'firebase';


/**
 * Generated class for the StockListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-takeaway-select-state',
  templateUrl: 'takeaway-select-state.html',
})
export class TakeawaySelectState {
  title: any;
  table: any;
  tags_show: any = [];
  classActive: string;
  check_change_state: boolean;
  public firestore: any;


  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public globals: Globals,
    public ordersServices: OrdersServices,
    public ordersCoServices: OrdersCoServices,
    public http: HttpClient,
    public translate: TranslateService,
    public afs: AngularFirestore,
    public takeawayServices: TakeawayServices) {
    this.firestore = firebase.firestore();

    this.title = this.navParams.get('title');
    this.table = this.navParams.get('table');
    this.check_change_state = false;

  }

  public state = [{
    'name': 'stateless',//'sin_estado',
    'active': false
  },
  {
    'name': 'received',//'recibida',
    'active': false
  },
  {
    'name': 'accepted',//'aceptada',
    'active': false
  },
  {
    'name': 'payment_completed',//'pago_completado',
    'active': false
  },
  {
    'name': 'kitchen',//'cocina',
    'active': false
  },
  {
    'name': 'ready_for_pickup',//'lista_para_el_rider',
    'active': false
  },
  {
    'name': 'prepared',//'preparada',
    'active': false
  },
  {
    'name': 'sent',//'enviada',
    'active': false
  },
  {
    'name': 'delayed_15',//'en retraso 15 min',
    'active': false
  },
  {
    'name': 'delayed_30',//'en retraso 30 in',
    'active': false
  },
  {
    'name': 'completed',//'completada',
    'active': false
  },
  {
    'name': 'cancelled',//'cancelada',
    'active': false
  }
  ];

  public state_girona = [
    {
      'name': 'received',//'recibida',
      'girona_state': 'No pagat',
      'active': false
    },
    {
      'name': 'accepted',//'aceptada',
      'girona_state': 'Pendent',
      'active': false
    },
    {
      'name': 'kitchen',//'cocina',
      'girona_state': 'Preparant-se',
      'active': false
    },
    {
      'name': 'prepared',//'preparada',
      'girona_state': 'Finalitzat',
      'active': false
    },
    {
      'name': 'completed',//'completada',
      'girona_state': 'Entregat',
      'active': false
    }];


  getState() {
    var state_name = '';
    if (!this.takeawayServices.is_girona) {
      if (this.table.deliverect_order_id != undefined && this.table.deliverect_order_id && this.table.deliverect_order_state && this.table.deliverect_order_state != undefined) {
        //pasamos el codigo a texto
        state_name = this.takeawayServices.getStateDeliverect(this.table.deliverect_order_state)
        for (let state of this.state) {
          //comapramos los textos para ver cual es el que esta activo
          if (state_name == state.name) {
            state.active = true;
          }
        }
      } else {
        for (let state of this.state) {
          if (this.table.order_state == state.name) {
            state.active = true;
          }
        }
      }
    } else {
      if (this.table.deliverect_order_id != undefined && this.table.deliverect_order_id && this.table.deliverect_order_state && this.table.deliverect_order_state != undefined) {
        //pasamos el codigo a texto
        state_name = this.takeawayServices.getStateDeliverect(this.table.deliverect_order_state)
        for (let state of this.state_girona) {
          //comapramos los textos para ver cual es el que esta activo
          if (state_name == state.name) {
            state.active = true;
          }
        }
      } else {
        for (let state of this.state_girona) {
          if (this.table.order_state == state.name) {
            state.active = true;
          }
        }
      }
    }

  }

  ionViewWillEnter() {
    this.getState();
  }

  close() {
    this.viewCtrl.dismiss();
  }

  changeState(name_state) {
    if (!this.takeawayServices.is_girona) {
      for (let state of this.state) {
        if (name_state == state.name) {
          state.active = true;
          this.check_change_state = true;
        } else {
          state.active = false;
        }
      }
    } else {
      for (let state of this.state_girona) {
        if (name_state == state.name) {
          state.active = true;
          this.check_change_state = true;
        } else {
          state.active = false;
        }
      }
    }
  }

  save() {
    if (!this.takeawayServices.is_girona) {
      //Comprobamos que haya cambiada el estado, principalmente para no estar enviando correos de cambios de estado constantemente.
      if (this.check_change_state) {
        //Miramos en que estado se ha seleccionado
        for (let state of this.state) {
          if (state.active) {
            //Comprobar que tenga la opción de deliverect activada y la deliverect order id

            if (this.table.deliverect_order_id != undefined && this.table.deliverect_order_id && this.globals.restaurant.deliverect != undefined && this.globals.restaurant.deliverect) {
              //actualizar el estado en deliverect
              this.updateDeliverect(this.table.deliverect_order_id, state.name);
              //actualizar el estado a firestore
              this.afs.collection('tables').doc(this.table.UID).update({
                'deliverect_order_state': this.takeawayServices.getCodeDeliverect(state.name),
                'order_state': state.name,
              });
            } else {
              //en caso de no ser de deliverect
              //actualizar el estado a firestore
              this.afs.collection('tables').doc(this.table.UID).update({
                'order_state': state.name,
              });
            }
            //prepare and send email
            this.takeawayServices.sendEmailOrderState(this.table, this.takeawayServices.formatState(state.name), this.table.customer_email, this.table.customer_name, this.table.customer_phone, this.table.customer_address);
            this.updateTicket(state.name);
          }
        }
      }
    } else {
      //Comprobamos que haya cambiada el estado, principalmente para no estar enviando correos de cambios de estado constantemente.
      if (this.check_change_state) {
        //Miramos en que estado se ha seleccionado
        for (let state of this.state_girona) {
          if (state.active) {
            //Comprobar que tenga la opción de deliverect activada y la deliverect order id

            if (this.table.deliverect_order_id != undefined && this.table.deliverect_order_id && this.globals.restaurant.deliverect != undefined && this.globals.restaurant.deliverect) {
              //actualizar el estado en deliverect
              this.updateDeliverect(this.table.deliverect_order_id, state.name);
              //actualizar el estado a firestore
              this.afs.collection('tables').doc(this.table.UID).update({
                'deliverect_order_state': this.takeawayServices.getCodeDeliverect(state.name),
                'order_state': state.name,
              });
            } else {
              //en caso de no ser de deliverect
              //actualizar el estado a firestore
              this.afs.collection('tables').doc(this.table.UID).update({
                'order_state': state.name,
              });
            }
            this.updateTicket(state.name);
            //this.sendEmail(this.takeawayServices.formatState(state.name), this.table.customer_email, this.table.customer_name, this.table.customer_phone)
          }
        }
      }
    }

    this.viewCtrl.dismiss();
  }



  async updateDeliverect(order_id, status) {
    await this.http.post(this.globals.analytics_path + 'deliverect_update_status', {
      orderid: order_id,
      status: this.takeawayServices.getCodeDeliverect(status),
      uid_restaurant: this.table.UID_RESTAURANT
    }, {}).subscribe(async data => {

    },
      err => {
      }
    );
  }

  async updateTicket(state) {
    var ticket_uid;
    await this.firestore.collection('tickets')
      .where('UID_RESTAURANT', '==', this.table.UID_RESTAURANT)
      .where('number', '==', this.table.ticket.number)
      .where('cash_uid', '==', this.table.cash_uid)
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          ticket_uid = doc.id;
          if (ticket_uid != undefined && this.table.deliverect_order_id != undefined && this.table.deliverect_order_id && this.globals.restaurant.deliverect != undefined && this.globals.restaurant.deliverect) {
            this.afs.collection('tickets').doc(ticket_uid).update({
              'deliverect_order_state': this.takeawayServices.getCodeDeliverect(state),
              'order_state': state
            });
          } else {
            if (ticket_uid != undefined) {
              this.afs.collection('tickets').doc(ticket_uid).update({
                'order_state': state
              });
            }

          }
        });
      });
  }

}



// WEBPACK FOOTER //
// ./src/pages/components/popups/takeaway-select-state/takeaway-select-state.ts